import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs4";
import { UserContext } from "../../App";
import { deleteVehicle, useVehicles } from "../../utils/vehicle";
import { NavItem, NavTabs } from "../layout/Nav";
import { verifyRight } from "../../utils/users";
import { StyledTr } from "./bookingContent";
import ActionsMenu from "../layout/ActionsMenu";
import TrashIcon from "../icons/TrashIcon";
import SelectionActionsPopup from "../layout/SelectionActionsPopup";
import { OutlineButtonLink } from "../layout/OutlineButton";

export default function VehicleContent() {
  const { userInfos } = useContext(UserContext);
  const [checked, setChecked] = useState([]);
  const { vehicles, loaded } = useVehicles();
  const datatable = useRef(null);

  useEffect(() => {
    if (datatable.current) {
      datatable.current.destroy();
      datatable.current = null;
    }

    window.setTimeout(() => {
      datatable.current = $("#datatable").DataTable({
        retrieve: true,
        order: [[1, "asc"]],
        pageLength: 25,
      });
    }, 1);
  }, [vehicles, loaded]);

  function handleCheckbox(e) {
    const { value, checked: isChecked } = e.target;

    if (isChecked) {
      setChecked((old) => [...old, value]);
    } else {
      setChecked((old) => old.filter((id) => id !== value));
    }
  }

  const datatableContent = useMemo(() => {
    return (
      <tbody>
        {vehicles.map((vehicle, index) => {
          let actions = [];

          if (verifyRight(userInfos, "vehicle", "update")) {
            actions.push({
              link: `/vehicle/${vehicle.id}`,
              label: "Modifier",
            });
          }

          if (verifyRight(userInfos, "vehicle", "delete")) {
            actions.push({
              label: "Supprimer",
              onClick: async () => {
                if (
                  !window.confirm(
                    "Voulez-vous vraiment supprimer ce véhicule ?"
                  )
                )
                  return;
                await deleteVehicle(userInfos, [vehicle.id]);
                window.location.reload();
              },
            });
          }

          return (
            <StyledTr
              key={vehicle.id}
              className={checked.includes(vehicle.id) ? "checked" : ""}
            >
              <td style={{ textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={checked.includes(vehicle.id)}
                  name="bulk_action"
                  value={vehicle.id}
                  onChange={handleCheckbox}
                />
              </td>
              <td>{index + 1}</td>
              <td>{vehicle.brand || "N/A"}</td>
              <td>{vehicle.model || "N/A"}</td>
              <td>{vehicle.plateNumber || "N/A"}</td>
              <td>{vehicle?.company?.name || "N/A"}</td>
              <td>
                <ActionsMenu items={actions} />
              </td>
            </StyledTr>
          );
        })}
      </tbody>
    );
  }, [vehicles, userInfos, checked]);

  const handleDeleteVehicle = useCallback(async () => {
    if (checked.length) {
      if (!window.confirm("Voulez-vous vraiment supprimer ces véhicules ?"))
        return;
      await deleteVehicle(userInfos, checked);
      window.location.reload();
    }
  }, [checked, userInfos]);

  const PortletFooter = useMemo(() => {
    let actions = [];
    if (verifyRight(userInfos, "vehicle", "delete"))
      actions.push({
        label: <TrashIcon />,
        title: "Supprimer",
        onClick: handleDeleteVehicle,
      });
    if (checked.length) {
      return (
        <SelectionActionsPopup
          selectedItemsLength={checked.length}
          resetChecked={() => setChecked([])}
          buttons={actions}
          items={[]}
        />
      );
    }
  }, [checked.length, handleDeleteVehicle, userInfos]);

  if (!loaded) {
    return (
      <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
          <div className="">
            <div className="kt-portlet__body">
              <div className="text-center">Chargement...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="body-container">
      <div className="title-container">
        <NavTabs className="titles">
          {verifyRight(userInfos, "company", "read") && (
            <NavItem>
              <Link to="/company">Entreprises</Link>
            </NavItem>
          )}
          {verifyRight(userInfos, "driver", "read") && (
            <NavItem>
              <Link to="/driver">Chauffeurs</Link>
            </NavItem>
          )}
          {verifyRight(userInfos, "vehicle", "read") && (
            <NavItem className="active">
              <Link to="/vehicle">Véhicules</Link>
            </NavItem>
          )}
        </NavTabs>
        <div className="header-toolbar">
          {verifyRight(userInfos, "vehicle", "create") && (
            <OutlineButtonLink to="/addVehicle/">
              <i className="la la-plus"></i>
              Nouveau véhicule
            </OutlineButtonLink>
          )}
        </div>
      </div>

      <div>
        <div className="kt-portlet--mobile">
          <div className="kt-portlet__body" style={{ overflowX: "scroll" }}>
            <table
              className="table table-striped- table-bordered table-hover table-checkable"
              id="datatable"
            >
              <thead>
                <tr>
                  <th
                    style={{ width: "5%", textAlign: "center" }}
                    data-sort="false"
                  >
                    Selection
                  </th>
                  <th style={{ width: "5%" }}>#</th>
                  <th style={{ width: "30%" }}>Marque</th>
                  <th style={{ width: "20%" }}>Modèle</th>
                  <th style={{ width: "20%" }}>Immatriculation</th>
                  <th style={{ width: "30%" }}>Compagnie</th>
                  <th style={{ width: "10%" }}>Action</th>
                </tr>
              </thead>
              {datatableContent}
            </table>
          </div>
          {PortletFooter}
        </div>
      </div>
    </div>
  );
}
